<div class="icon-text-date-cell">
  <div class="icon-text-date-cell-container">
    <div class="flex-item">
      <img class="icon-text-date-cell-img" src="{{ userInfo?.photo }}" />
    </div>

    <div class="flex-div">
      <p class="icon-text-date-cell-text-grey-bold-16px">
        {{ userInfo?.name }}
      </p>
      <span
        class="icon-text-date-cell-text-grey-bold-16px"
        [style.color]="
          activeStatus == 'Acesso Habilitado' ? '#20A344' : '#808080'
        "
      >
        {{ activeStatus }}
      </span>
      <p
        class="icon-text-date-cell-text-grey-bold-14px"
        *ngFor="let profile of userInfo?.profiles"
      >
        {{ profile }}
      </p>

      <p class="icon-text-date-cell-text-grey-bold-14px">
        {{ userInfo?.email }}
      </p>
    </div>
    <div class="icon-text-date-cell-toggle">
      <mat-slide-toggle
        (click)="onClick($event)"
        (change)="onChange($event)"
        [checked]="isChecked(statusToggle)"
      >
      </mat-slide-toggle>
    </div>
  </div>
</div>
